"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _EventRelay = require("../../core/EventRelay");

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

var _UIModalDialog = _interopRequireDefault(require("../UIModalDialog"));

var _UIFullScreen = _interopRequireDefault(require("../UIFullScreen"));

var _getTransitionProps = _interopRequireDefault(require("./getTransitionProps"));

var AbstractModal = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AbstractModal, _Component);

  function AbstractModal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AbstractModal);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AbstractModal).call(this, props));
    _this._closeStartRelay = (0, _EventRelay.makeEventRelay)();
    _this._openCompleteRelay = (0, _EventRelay.makeEventRelay)();
    _this._getTransitionProps = (0, _memoizeOne.default)(_getTransitionProps.default);
    return _this;
  }

  (0, _createClass2.default)(AbstractModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          componentName = _this$props.componentName,
          _contextual = _this$props._contextual,
          ModalDialog = _this$props.ModalDialog,
          onOpenStart = _this$props.onOpenStart,
          onOpenComplete = _this$props.onOpenComplete,
          onCloseStart = _this$props.onCloseStart,
          onCloseComplete = _this$props.onCloseComplete,
          Transition = _this$props.Transition,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["componentName", "_contextual", "ModalDialog", "onOpenStart", "onOpenComplete", "onCloseStart", "onCloseComplete", "Transition"]);
      var sandboxed = _contextual || this.context.sandboxed;

      var renderedModalDialog = _react.default.createElement(ModalDialog, (0, _extends2.default)({}, rest, {
        contextual: _contextual,
        _openCompleteRelay: sandboxed ? null : this._openCompleteRelay,
        _closeStartRelay: sandboxed ? null : this._closeStartRelay
      }));

      return sandboxed ? renderedModalDialog : _react.default.createElement(_UIFullScreen.default, {
        "data-layer-for": componentName,
        Transition: Transition,
        transitionProps: this._getTransitionProps(onOpenStart, this._openCompleteRelay.getHandle(onOpenComplete), this._closeStartRelay.getHandle(onCloseStart), onCloseComplete)
      }, renderedModalDialog);
    }
  }]);
  return AbstractModal;
}(_react.Component);

exports.default = AbstractModal;

if (process.env.NODE_ENV !== 'production') {
  AbstractModal.propTypes = {
    componentName: _propTypes.default.string.isRequired,
    _contextual: _propTypes.default.bool,
    ModalDialog: _propTypes.default.elementType.isRequired,
    onOpenStart: _propTypes.default.func,
    onOpenComplete: _propTypes.default.func,
    onCloseStart: _propTypes.default.func,
    onCloseComplete: _propTypes.default.func,
    Transition: _propTypes.default.elementType
  };
}

AbstractModal.contextTypes = {
  sandboxed: _propTypes.default.bool
};
AbstractModal.defaultProps = {
  ModalDialog: _UIModalDialog.default
};
AbstractModal.displayName = 'AbstractModal';
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/dialog/internal/AbstractModal.js
// module id = 389
// module chunks = 209 210 211 212